import React from 'react'
import { Card } from 'react-bootstrap';
export default class newsSection extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
          <div className="row rtl justify-content-center">
           <div className="col-12 col-md-4">
             <div className=" news-card ">
             <div className=" news-img img-gradient">
            
              <img src="https://i.ibb.co/3kCfHRp/Hairdresser-cut-hair-her-client-Woman-in-a-hair-salon.jpg" />
              
             </div>
             <p>
               تعلن شركة هاد مرشد الأعمال عن إصدارها لأول رخصة حاضنة أعمال مهنية للتزيين النسائي
               </p>
             </div>
           </div>
           <div className="col-12 col-md-4">
             <div className=" news-card ">
             <div className=" news-img img-gradient">
            
              <img src="https://i.ibb.co/H4LnFRt/Group-of-three-young-multi-ethnic-successful-business-people-sitting-in-coworking-space-talking-abou.jpg" />
              
             </div>
             <p>
             استمرار استقبال تنفيذ المبادرات الحكومية للشركات الناشئة
               </p>
             </div>
           </div>
           <div className="col-12 col-md-4">
             <div className=" news-card ">
             <div className=" news-img img-gradient">
            
              <img src="https://i.ibb.co/VTfR0cZ/Doctor-epidemiologist-fighting-with-coronavirus-COVID-19-Nurse-wears-a-protective-suit-and-mask-duri.jpg" />
              
             </div>
             <p>
             تيسير متابعة الأعمال الحكومية عن بعد أثناء جائحة كورونا والذي ينم عن ٤٠ عميل جديد
               </p>
             </div>
           </div>
           <div className="col-12 col-md-4">
             <div className=" news-card ">
             <div className=" news-img img-gradient">
            
              <img src="https://i.ibb.co/syTQWxb/Image-of-business-partners-handshaking-over-business-objects-on-workplace.jpg" />
              
             </div>
             <p>
             خدمات وميزات جديدة للمشاريع المتقدمة من خارج المملكة العربية السعودية
               </p>
             </div>
           </div>
          {/*   <div className="col-12 col-md-4 mx-auto">
                <Card className="news-card ">
                  <div className="img-gradient">
                  <Card.Img variant="top" src="https://i.ibb.co/3kCfHRp/Hairdresser-cut-hair-her-client-Woman-in-a-hair-salon.jpg" className="img-fluid" />
                  </div>
                 
                <Card.Body  className="news-body">
                  <Card.Text className="news-body">
                  تعلن شركة هاد مرشد الأعمال عن إصدارها لأول رخصة حاضنة أعمال مهنية للتزيين النسائي
                  </Card.Text>
                </Card.Body>
            </Card>
             </div>
             <div className="col-12 col-md-4 mx-auto">
                <Card>
                <div className="img-gradient">
              <Card.Img variant="top" src="https://i.ibb.co/H4LnFRt/Group-of-three-young-multi-ethnic-successful-business-people-sitting-in-coworking-space-talking-abou.jpg" />
              </div>
                <Card.Body>
                  <Card.Text>
                  استمرار استقبال تنفيذ المبادرات الحكومية للشركات الناشئة

                  </Card.Text>
                </Card.Body>
            </Card>
             </div>
             <div className="col-12 col-md-4 mx-auto">
                <Card>
                <div className="img-gradient">
              <Card.Img variant="top" src="https://i.ibb.co/VTfR0cZ/Doctor-epidemiologist-fighting-with-coronavirus-COVID-19-Nurse-wears-a-protective-suit-and-mask-duri.jpg" />
              </div>
                <Card.Body>
                  <Card.Text>
                  تيسير متابعة الأعمال الحكومية عن بعد أثناء جائحة كورونا والذي ينم عن ٤٠ عميل جديد
                  </Card.Text>
                </Card.Body>
            </Card>
             </div>
             <div className="col-12 col-md-4 mx-auto">
             <Card>
             <div className="img-gradient">
              <Card.Img variant="top" src="https://i.ibb.co/syTQWxb/Image-of-business-partners-handshaking-over-business-objects-on-workplace.jpg" />
              </div>
                <Card.Body>
                  <Card.Text>
                  خدمات وميزات جديدة للمشاريع المتقدمة من خارج المملكة العربية السعودية

                  </Card.Text>
                </Card.Body>
            </Card>
            </div> */}
            </div>
        )
    }
}
